// Coordinacion de actualizaciones del Service Worker entre multiples pestañas
// abiertas de la misma app.
//
// Why: si un usuario tiene varias pestañas abiertas y una detecta una version
// nueva del SW, el resto siguen ejecutando el bundle viejo en memoria. Usamos
// BroadcastChannel para que todas las pestañas se enteren al mismo tiempo y
// muestren el banner "Actualizar ahora", y para que cuando una pestaña aplique
// el update las demas tambien recarguen.
//
// Mensajes:
//   - 'update-available': alguna pestaña detecto un SW en waiting.
//   - 'update-applying':  el usuario acepto actualizar. Todas deben recargar.

export type SwUpdateBroadcastMessage =
  | { type: 'update-available' }
  | { type: 'update-applying' };

const CHANNEL_NAME = 'sw-update-coord';

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel | null {
  if (typeof window === 'undefined') return null;
  if (typeof BroadcastChannel === 'undefined') return null; // Safari < 15.4 / IE
  if (channel) return channel;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
  } catch {
    channel = null;
  }
  return channel;
}

export function broadcastSwUpdate(message: SwUpdateBroadcastMessage): void {
  const ch = getChannel();
  if (!ch) return;
  try {
    ch.postMessage(message);
  } catch {
    // Si el canal esta cerrado o el mensaje no es serializable, no romper.
  }
}

export function subscribeSwUpdateBroadcast(
  handler: (message: SwUpdateBroadcastMessage) => void
): () => void {
  const ch = getChannel();
  if (!ch) return () => undefined;
  const listener = (ev: MessageEvent<SwUpdateBroadcastMessage>) => {
    if (!ev?.data || typeof ev.data !== 'object') return;
    handler(ev.data);
  };
  ch.addEventListener('message', listener);
  return () => {
    try {
      ch.removeEventListener('message', listener);
    } catch {
      // ignore
    }
  };
}
